import gql from 'graphql-tag'

export const fetchTransportTypeMutation = gql(`
mutation ($cart_id: String!, $transporttype: String!, $outletid: Int!, $datepopup: String!, $store: String!, $sappaymentcode: String, $sappaymentmethod: String) {
  setTransportType(
      cart_id: $cart_id
      transporttype: $transporttype
      outletid: $outletid
      datepopup: $datepopup
      store: $store
      sappaymentcode: $sappaymentcode
      sappaymentmethod: $sappaymentmethod
  ) {
    message
  }
}
`)
